var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, Typography } from '@mui/material';
import { userInformation } from '@src/app/helper';
import { handleFocus } from '@src/app/helper/NumberHelpers';
import { useBanks } from '@src/app/pages/BankPage/BankHooks/Bank.hooks';
import { uploadFile } from '@src/app/pages/JobPage/Job/Job.requests';
import { useActivityById, useJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
import { useBankTransfer, useCities, useCompanies, useCouriers, } from '@src/app/pages/LookupPage/LookupHooks/Lookup.hooks';
import { useProductCategory } from '@src/app/pages/ProductCategoryPage/ProductCategoryHooks/ProductCategory.hooks';
import { useSaldoTeams } from '@src/app/pages/SaldoTeamPage/SaldoTeamHooks/SaldoTeam.hooks';
import { useTalentAddresses, useTalentBankAccounts, } from '@src/app/pages/TalentPage/TalentHooks/TalentDetail.hooks';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import FileFormik from '@src/components/Atoms/Formik/Input/FileFormik';
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import MultiSelectFormik from '@src/components/Atoms/Formik/MultiSelect/MultiSelectFormik';
import SelectFormik from '@src/components/Atoms/Formik/Select/SelectFormik';
import TextAreaFormik from '@src/components/Atoms/Formik/TextArea/TextAreaFormik';
import { defaultOptionAddress, defaultOptionBank, defaultOptionSendItem, } from '@src/components/molecules/Job/Job.constant';
import { useFormik } from 'formik';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import SendProductForm from '../../SendProduct/Form/SendProductForm';
import { dummyNpwpStatusOptions, dummyTaxMethodOptions, dummyTaxOptions, dummyTaxTypeOptions, dummyTransferMethodOptions, dummyTransferOption, } from '../../Transfer/Transfer.constant';
import { NpwpStatus, PajakCategory, PajakMethod, PajakType, TransferMethod, } from '../../Transfer/Transfer.enum';
import Activity from '@src/app/pages/JobPage/JobDetail/Activity/Activity';
import { useGenerateTax } from '@src/app/pages/JobPage/JobHooks/JobDetail.hooks';
var JobProcessFormSchema = Yup.object().shape({
    talentAddressPubId: Yup.string().required('Field belum diisi'),
    address: Yup.object().when('talentAddressPubId', {
        is: function (talentAddressPubId) { return talentAddressPubId === 'add-new'; },
        then: Yup.object().shape({
            recipientName: Yup.string().required('Field belum diisi'),
            recipientPhoneNumber: Yup.string(),
            address: Yup.string().required('Field belum diisi'),
            cityPubId: Yup.string().required('Field belum diisi'),
        }),
        otherwise: Yup.object().shape({
            recipientName: Yup.string(),
            recipientPhoneNumber: Yup.string(),
            address: Yup.string(),
            cityPubId: Yup.string(),
        }),
    }),
    talentBankAccountPubId: Yup.string().required('Field belum diisi'),
    bank: Yup.object().when('talentBankAccountPubId', {
        is: function (talentBankAccountPubId) { return talentBankAccountPubId === 'add-new'; },
        then: Yup.object().shape({
            bankPubId: Yup.string().required('Field belum diisi'),
            accountNumber: Yup.string().required('Field belum diisi'),
            accountName: Yup.string().required('Field belum diisi'),
            branchName: Yup.string(),
            cityPubId: Yup.string(),
        }),
        otherwise: Yup.object().shape({
            bankPubId: Yup.string(),
            accountNumber: Yup.string(),
            accountName: Yup.string(),
            branchName: Yup.string(),
            cityPubId: Yup.string(),
        }),
    }),
    isSendProduct: Yup.string().required('Field belum diisi'),
    sendProduct: Yup.object().when('isSendProduct', {
        is: function (isSendProduct) { return isSendProduct === 'Send Item'; },
        then: Yup.object().shape({
            products: Yup.array()
                .of(Yup.object().shape({
                productPubId: Yup.string().required('Field belum diisi'),
                productCategoryPubId: Yup.string().required('Field belum diisi'),
                qty: Yup.string().required('Field belum diisi'),
            }))
                .min(1, 'Minimum 1 Item'),
            courierPubId: Yup.string().required('Field belum diisi'),
            notes: Yup.string(),
        }),
        otherwise: Yup.object()
            .shape({
            courierPubId: Yup.string(),
            notes: Yup.string(),
        })
            .nullable(),
    }),
    pajakType: Yup.string().required('Field belum diisi'),
    pajakMethod: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakCategory: Yup.string().when('pajakMethod', {
        is: function (pajakMethod) { return pajakMethod === PajakMethod.INCLUDED; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakBruto: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakFee: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakPPN: Yup.string().when(['pajakType', 'pajakCategory'], {
        is: function (pajakType, pajakCategory) {
            return pajakType === PajakType.PAJAK && pajakCategory === PajakCategory.PPH23PLUSPPN;
        },
        then: Yup.string().required('Field belum diisi'),
    }),
    ktpNumber: Yup.string().required('Field belum diisi').max(16, 'Maksimal 16 karakter'),
    ktpName: Yup.string().required('Field belum diisi'),
    npwpStatus: Yup.string().required('Field belum diisi'),
    npwpNumber: Yup.string().when('npwpStatus', {
        is: function (npwpStatus) { return npwpStatus === 'have-npwp'; },
        then: Yup.string()
            .required('NPWP Number is required')
            .matches(/^\d{2}\.\d{3}\.\d{3}.\d{1}-\d{3}\.\d{3,}$/, 'NPWP minimal 15 digit'),
        otherwise: Yup.string().nullable(),
    }),
    npwpName: Yup.string().when('npwpStatus', {
        is: function (npwpStatus) { return npwpStatus === 'have-npwp'; },
        then: Yup.string().required('Field belum diisi'),
        otherwise: Yup.string().nullable(),
    }),
    paymentMethod: Yup.string().required('Field belum diisi'),
    transferMethod: Yup.string().required('Field belum diisi'),
    termTransferAmount: Yup.string().when('transferMethod', {
        is: function (transferMethod) { return transferMethod === TransferMethod.TRANSFERPERTERM; },
        then: Yup.string().required('Field belum diisi'),
    }),
    invoiceFilePubId: Yup.mixed().required('Field belum diisi'),
    spkFilePubId: Yup.mixed(),
    bankTransferByPubId: Yup.string().required('Field belum diisi'),
    companyPubId: Yup.string().required('Field belum diisi'),
});
var ProcessJob = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    var isOpen = _a.isOpen, handleClose = _a.handleClose, record = _a.record, id = _a.id, details = _a.details;
    var navigate = useNavigate();
    var jobInitialValues = {
        talentAddressPubId: ((_c = (_b = record === null || record === void 0 ? void 0 : record.job) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.pubId) || '',
        talentBankAccountPubId: ((_e = (_d = record === null || record === void 0 ? void 0 : record.job) === null || _d === void 0 ? void 0 : _d.bankAccount) === null || _e === void 0 ? void 0 : _e.pubId) || '',
        address: {
            recipientName: ((_g = (_f = record === null || record === void 0 ? void 0 : record.job) === null || _f === void 0 ? void 0 : _f.address) === null || _g === void 0 ? void 0 : _g.recipientName) || '',
            recipientPhoneNumber: ((_j = (_h = record === null || record === void 0 ? void 0 : record.job) === null || _h === void 0 ? void 0 : _h.address) === null || _j === void 0 ? void 0 : _j.recipientPhoneNumber) || '',
            address: ((_l = (_k = record === null || record === void 0 ? void 0 : record.job) === null || _k === void 0 ? void 0 : _k.address) === null || _l === void 0 ? void 0 : _l.address) || '',
            cityPubId: ((_p = (_o = (_m = record === null || record === void 0 ? void 0 : record.job) === null || _m === void 0 ? void 0 : _m.address) === null || _o === void 0 ? void 0 : _o.city) === null || _p === void 0 ? void 0 : _p.pubId) || '',
        },
        bank: {
            bankPubId: ((_r = (_q = record === null || record === void 0 ? void 0 : record.job) === null || _q === void 0 ? void 0 : _q.bankAccount) === null || _r === void 0 ? void 0 : _r.pubId) || '',
            accountNumber: ((_t = (_s = record === null || record === void 0 ? void 0 : record.job) === null || _s === void 0 ? void 0 : _s.bankAccount) === null || _t === void 0 ? void 0 : _t.accountNumber) || '',
            accountName: ((_v = (_u = record === null || record === void 0 ? void 0 : record.job) === null || _u === void 0 ? void 0 : _u.bankAccount) === null || _v === void 0 ? void 0 : _v.accountName) || '',
            branchName: ((_x = (_w = record === null || record === void 0 ? void 0 : record.job) === null || _w === void 0 ? void 0 : _w.bankAccount) === null || _x === void 0 ? void 0 : _x.branchName) || '',
            cityPubId: ((_0 = (_z = (_y = record === null || record === void 0 ? void 0 : record.job) === null || _y === void 0 ? void 0 : _y.bankAccount) === null || _z === void 0 ? void 0 : _z.city) === null || _0 === void 0 ? void 0 : _0.pubId) || '',
        },
        details: details &&
            details.map(function (data) { return ({
                profilePubId: data.profile.pubId,
                jobTypePubId: data.jobType.pubId,
                exclusiveStatus: data.exclusiveStatus,
                fee: data.fee,
                totalPosts: data.totalPosts,
                totalFollowers: data.totalFollowers,
                timeFrame: data.timeFrame,
                notes: data.notes,
            }); }),
        sendProduct: {
            products: [{ productPubId: '', qty: 1, productCategoryPubId: '' }],
            courierPubId: '',
            notes: '',
        },
        ktpNumber: (record === null || record === void 0 ? void 0 : record.talent.ktpNumber) || '',
        ktpName: (record === null || record === void 0 ? void 0 : record.talent.ktpName) || '',
        npwpNumber: (record === null || record === void 0 ? void 0 : record.talent.npwpName) || '',
        npwpName: ((_1 = record === null || record === void 0 ? void 0 : record.talent.npwpNumber) === null || _1 === void 0 ? void 0 : _1.trim()) || '',
        npwpStatus: '',
        totalTransferredFee: '',
        spkFilePubId: '',
        invoiceFilePubId: '',
        isSendProduct: '',
        pajakType: '',
        pajakMethod: '',
        pajakCategory: '',
        pajakBruto: '',
        pajakFee: '',
        pajakPPN: '',
        paymentMethod: '',
        transferMethod: '',
        termTransferAmount: '',
        termNote: '',
        bankTransferByPubId: '',
        companyPubId: '',
    };
    var _8 = useState(false), isTerm = _8[0], setIsTerm = _8[1];
    var _9 = useState(), detailAddress = _9[0], setDetailAddress = _9[1];
    var _10 = useState(false), loading = _10[0], setLoading = _10[1];
    var _11 = useState([]), selectedAddress = _11[0], setSelectedAddress = _11[1];
    var _12 = useState([]), selectedBankAccount = _12[0], setSelectedBankAccount = _12[1];
    var _13 = useState([]), selectedCityAddress = _13[0], setSelectedCityAddress = _13[1];
    var _14 = useState([]), selectedBankName = _14[0], setSelectedBankName = _14[1];
    var _15 = useState([]), selectedCityBank = _15[0], setSelectedCityBank = _15[1];
    var _16 = useState([]), selectedCourier = _16[0], setSelectedCourier = _16[1];
    var _17 = useState([]), selectedCategory = _17[0], setSelectedCategory = _17[1];
    var _18 = useState([]), selectedProduct = _18[0], setSelectedProduct = _18[1];
    var _19 = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: '',
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filter = _19[0], setFilter = _19[1];
    var _20 = useState({
        page: 1,
        pageSize: 200,
        keyword: '',
        filterBy: '',
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filterPageSize = _20[0], setFilterPageSize = _20[1];
    var _21 = useActivityById(id, {
        enabled: isOpen,
    }), activityData = _21.data, refetch = _21.refetch;
    var teamPubId = JSON.parse(userInformation).teams;
    var _22 = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: "[['team.pubId', '".concat((_2 = teamPubId[0]) === null || _2 === void 0 ? void 0 : _2.pubId, "']]"),
        initialFilterBy: "[]",
    }), filterSaldoTeam = _22[0], setFilterSaldoTeam = _22[1];
    var _23 = useState({
        invoiceFilePubId: '',
        spkFilePubId: '',
    }), files = _23[0], setFiles = _23[1];
    var _24 = useState(jobInitialValues), initialFormValues = _24[0], setInitialFormValues = _24[1];
    var _25 = useTalentBankAccounts(record === null || record === void 0 ? void 0 : record.talent.pubId, {
        isAllStatus: true,
    }), bankAccounts = _25.bankAccounts, isLoadingBankAccount = _25.isLoading;
    var _26 = useTalentAddresses(record === null || record === void 0 ? void 0 : record.talent.pubId, {
        isAllStatus: true,
    }), addresses = _26.addresses, isLoadingAddress = _26.isLoading;
    var cities = useCities().cities;
    var banks = useBanks(filterPageSize).banks;
    var finalRecapJob = useJob().finalRecapJob;
    var _27 = useCouriers(), couriers = _27.couriers, isLoadingCouriers = _27.isLoading;
    var _28 = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: "[[]]",
        initialFilterBy: "[[]]",
    }), filterBankTransfer = _28[0], setFilterBankTransfer = _28[1];
    var _29 = useBankTransfer(filterBankTransfer), bankTransfer = _29.bankTransfer, isLoadingBankTransfer = _29.isLoading, refetchBankTransfer = _29.refetch;
    var productCategory = useProductCategory().productCategory;
    var saldoTeams = useSaldoTeams(filterSaldoTeam).saldoTeams;
    var _30 = useState([]), selectedCompany = _30[0], setSelectedCompany = _30[1];
    var _31 = useState(0), bankTransferValue = _31[0], setBankTransferValue = _31[1];
    var companies = useCompanies().companies;
    var optionCompanies = companies &&
        companies.data &&
        companies.data.length > 0 &&
        companies.data.map(function (company) { return ({
            label: company.name,
            value: company.pubId,
        }); });
    var onChangeCompany = function (e) {
        setSelectedCompany(e);
        JobProcessFormik.setFieldValue('companyPubId', e.value);
        filterBankTransfer['initialFilterBy'] = "[[\"company.PubId\", \"".concat(e.value, "\"]]");
        setBankTransferValue(bankTransferValue + 1);
    };
    useEffect(function () {
        refetchBankTransfer();
    }, [bankTransferValue]);
    useEffect(function () {
        bankTransferValue > 0 && JobProcessFormik.setFieldValue('bankTransferByPubId', bankTransfer === null || bankTransfer === void 0 ? void 0 : bankTransfer.data[0].pubId);
    }, [bankTransfer]);
    var JobProcessFormik = useFormik({
        enableReinitialize: true,
        initialValues: initialFormValues,
        validationSchema: JobProcessFormSchema,
        onSubmit: function (values, _a) {
            var resetForm = _a.resetForm, setErrors = _a.setErrors, setStatus = _a.setStatus, setSubmitting = _a.setSubmitting;
            return __awaiter(void 0, void 0, void 0, function () {
                var spk, invoice, formValues, addressDetails, addressRecipientName, addressRecipientNumber, addressCity, bankPubId, bankAccountName, bankAccountNumber, bankOfficeBranch, bankCity, talentAddressPubId, talentBankAccountPubId, totalTransferredFee, bank, address, npwpName, npwpNumber, npwpStatus, pajakType, pajakBruto, pajakCategory, pajakMethod, pajakFee, pajakPPN, termTransferAmount, spkFilePubId, isSendProduct, sendProduct, transferMethod, value, finalPajakFee, finalPajakPPN, finalPajakBruto, finalTotalTransferredFee, finalTermTransferAmount, finalFormValue, invoiceFormValue, spkFormValue, bankAndAddressFormValue, sendProductFormValue, pajakFormValue, pajakPPNFormValue, npwpFormValue, transferFormValue, formData, e_1, error;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            setLoading(true);
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 8, 9, 10]);
                            spk = void 0;
                            if (!files.spkFilePubId) return [3 /*break*/, 3];
                            return [4 /*yield*/, uploadFile({
                                    File: files.spkFilePubId[0],
                                    TenantPubId: record.talent.tenant.pubId,
                                    TalentPubId: record.talent.pubId,
                                    Type: 'SPKs',
                                })];
                        case 2:
                            spk = _c.sent();
                            _c.label = 3;
                        case 3: return [4 /*yield*/, uploadFile({
                                File: files.invoiceFilePubId[0],
                                TenantPubId: record.talent.tenant.pubId,
                                TalentPubId: record.talent.pubId,
                                Type: 'Invoices',
                            })];
                        case 4:
                            invoice = _c.sent();
                            if (!((invoice === null || invoice === void 0 ? void 0 : invoice.status) === 200 || (invoice === null || invoice === void 0 ? void 0 : invoice.data))) return [3 /*break*/, 6];
                            formValues = __assign({ id: id }, values);
                            addressDetails = formValues.addressDetails, addressRecipientName = formValues.addressRecipientName, addressRecipientNumber = formValues.addressRecipientNumber, addressCity = formValues.addressCity, bankPubId = formValues.bankPubId, bankAccountName = formValues.bankAccountName, bankAccountNumber = formValues.bankAccountNumber, bankOfficeBranch = formValues.bankOfficeBranch, bankCity = formValues.bankCity, talentAddressPubId = formValues.talentAddressPubId, talentBankAccountPubId = formValues.talentBankAccountPubId, totalTransferredFee = formValues.totalTransferredFee, bank = formValues.bank, address = formValues.address, npwpName = formValues.npwpName, npwpNumber = formValues.npwpNumber, npwpStatus = formValues.npwpStatus, pajakType = formValues.pajakType, pajakBruto = formValues.pajakBruto, pajakCategory = formValues.pajakCategory, pajakMethod = formValues.pajakMethod, pajakFee = formValues.pajakFee, pajakPPN = formValues.pajakPPN, termTransferAmount = formValues.termTransferAmount, spkFilePubId = formValues.spkFilePubId, isSendProduct = formValues.isSendProduct, sendProduct = formValues.sendProduct, transferMethod = formValues.transferMethod, value = __rest(formValues, ["addressDetails", "addressRecipientName", "addressRecipientNumber", "addressCity", "bankPubId", "bankAccountName", "bankAccountNumber", "bankOfficeBranch", "bankCity", "talentAddressPubId", "talentBankAccountPubId", "totalTransferredFee", "bank", "address", "npwpName", "npwpNumber", "npwpStatus", "pajakType", "pajakBruto", "pajakCategory", "pajakMethod", "pajakFee", "pajakPPN", "termTransferAmount", "spkFilePubId", "isSendProduct", "sendProduct", "transferMethod"]);
                            finalPajakFee = (pajakFee !== null && pajakFee !== void 0 ? pajakFee : '').toString().replace(/\./g, '');
                            finalPajakPPN = (pajakPPN !== null && pajakPPN !== void 0 ? pajakPPN : '').toString().replace(/\./g, '');
                            finalPajakBruto = (pajakBruto !== null && pajakBruto !== void 0 ? pajakBruto : '').toString().replace(/\./g, '');
                            finalTotalTransferredFee = (totalTransferredFee !== null && totalTransferredFee !== void 0 ? totalTransferredFee : '').toString().replace(/\./g, '');
                            finalTermTransferAmount = (termTransferAmount !== null && termTransferAmount !== void 0 ? termTransferAmount : '').toString().replace(/\./g, '');
                            finalFormValue = value;
                            invoiceFormValue = {};
                            spkFormValue = {};
                            bankAndAddressFormValue = {};
                            sendProductFormValue = {};
                            pajakFormValue = {};
                            pajakPPNFormValue = {};
                            npwpFormValue = {};
                            transferFormValue = {};
                            invoiceFormValue = {
                                invoiceFilePubId: invoice.data.data.pubId,
                                spkFilePubId: (_b = spk === null || spk === void 0 ? void 0 : spk.data.data.pubId) !== null && _b !== void 0 ? _b : '',
                            };
                            if (typeof files.spkFilePubId !== 'string' && spk) {
                                spkFormValue = {
                                    spkFilePubId: spk.data.data.pubId,
                                };
                            }
                            if (talentAddressPubId === 'add-new' && talentBankAccountPubId !== 'add-new') {
                                bankAndAddressFormValue = {
                                    address: address,
                                    talentBankAccountPubId: talentBankAccountPubId,
                                };
                            }
                            else if (talentAddressPubId !== 'add-new' && talentBankAccountPubId === 'add-new') {
                                bankAndAddressFormValue = {
                                    bank: bank,
                                    talentAddressPubId: talentAddressPubId,
                                };
                            }
                            else if (talentAddressPubId === 'add-new' && talentBankAccountPubId === 'add-new') {
                                bankAndAddressFormValue = {
                                    address: address,
                                    bank: bank,
                                };
                            }
                            else if (talentAddressPubId !== 'add-new' && talentBankAccountPubId !== 'add-new') {
                                bankAndAddressFormValue = {
                                    talentAddressPubId: talentAddressPubId,
                                    talentBankAccountPubId: talentBankAccountPubId,
                                };
                            }
                            if (isSendProduct === 'Not Send Item') {
                                sendProductFormValue = { sendProduct: null };
                            }
                            else {
                                sendProductFormValue = { sendProduct: sendProduct };
                            }
                            if (pajakType === PajakType.PAJAK) {
                                pajakFormValue = {
                                    pajakType: pajakType,
                                    pajakMethod: pajakMethod,
                                    pajakCategory: pajakCategory,
                                    pajakBruto: finalPajakBruto,
                                    pajakFee: finalPajakFee,
                                    totalTransferredFee: finalTotalTransferredFee,
                                };
                            }
                            else {
                                pajakFormValue = { pajakType: pajakType };
                            }
                            if (pajakType === PajakType.PAJAK &&
                                (pajakCategory === PajakCategory.PPh23PlusPPNInc ||
                                    pajakCategory === PajakCategory.PPh23PlusPPNExc ||
                                    pajakCategory === PajakCategory.PPh4ayat2PlusPPNInc ||
                                    pajakCategory === PajakCategory.PPh4ayat2PlusPPNExc)) {
                                pajakPPNFormValue = {
                                    pajakPPN: finalPajakPPN,
                                };
                            }
                            if (npwpStatus === 'have-npwp') {
                                npwpFormValue = {
                                    npwpName: npwpName,
                                    npwpNumber: npwpNumber,
                                };
                            }
                            if (transferMethod === TransferMethod.TRANSFERPERTERM) {
                                transferFormValue = {
                                    termTransferAmount: finalTermTransferAmount,
                                    transferMethod: transferMethod,
                                };
                            }
                            else {
                                transferFormValue = { transferMethod: transferMethod };
                            }
                            formData = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, finalFormValue), invoiceFormValue), spkFormValue), bankAndAddressFormValue), sendProductFormValue), pajakFormValue), pajakPPNFormValue), npwpFormValue), transferFormValue);
                            return [4 /*yield*/, finalRecapJob(formData)];
                        case 5:
                            _c.sent();
                            handleClose();
                            resetForm({ values: initialFormValues });
                            return [3 /*break*/, 7];
                        case 6:
                            console.warn('Invoice upload failed, skipping save.');
                            _c.label = 7;
                        case 7: return [3 /*break*/, 10];
                        case 8:
                            e_1 = _c.sent();
                            error = e_1.response.data;
                            setStatus(error.message);
                            setErrors(error.message);
                            toast.error(error.message);
                            return [3 /*break*/, 10];
                        case 9:
                            setSubmitting(false);
                            setLoading(false);
                            return [7 /*endfinally*/];
                        case 10: return [2 /*return*/];
                    }
                });
            });
        }
    });
    var bankAccountOptions = useMemo(function () {
        return __spreadArray(__spreadArray([], defaultOptionBank, true), ((bankAccounts === null || bankAccounts === void 0 ? void 0 : bankAccounts.map(function (bank) { return ({
            label: "".concat(bank.accountName, " - ").concat(bank.accountNumber, " - ").concat(bank.bank.name),
            value: bank.pubId,
        }); })) || []), true);
    }, [bankAccounts]);
    var autoloadSelectedBankAccount = function (accountPubId) {
        setSelectedBankAccount(bankAccountOptions.filter(function (account) { return account.value === accountPubId; }));
    };
    useEffect(function () {
        var _a;
        if (((_a = record === null || record === void 0 ? void 0 : record.job) === null || _a === void 0 ? void 0 : _a.bankAccount) && bankAccountOptions.length > 1) {
            autoloadSelectedBankAccount(record.job.bankAccount.pubId);
        }
    }, [record, bankAccountOptions]);
    useEffect(function () {
        record && JobProcessFormik.setFieldValue('pajakBruto', record === null || record === void 0 ? void 0 : record.job.totalFee);
        filterTaxFee['totalTransferredFee'] = record === null || record === void 0 ? void 0 : record.job.totalFee;
    }, []);
    var bankList = banks &&
        banks.data &&
        banks.data.length > 0 &&
        banks.data.map(function (bank) { return ({
            label: bank.name,
            value: bank.pubId,
        }); });
    var courierList = couriers &&
        couriers.data &&
        couriers.data.length > 0 &&
        couriers.data.map(function (courier) { return ({
            label: courier.name,
            value: courier.pubId,
        }); });
    var addressOptions = useMemo(function () {
        return __spreadArray(__spreadArray([], defaultOptionAddress, true), ((addresses === null || addresses === void 0 ? void 0 : addresses.map(function (address) { return ({
            label: address.address,
            value: address.pubId,
        }); })) || []), true);
    }, [addresses]);
    var autoloadSelectedAddress = function (addressPubId) {
        setSelectedAddress(addressOptions.filter(function (address) { return address.value === addressPubId; }));
    };
    useEffect(function () {
        var _a;
        if (((_a = record === null || record === void 0 ? void 0 : record.job) === null || _a === void 0 ? void 0 : _a.address) && addressOptions.length > 1) {
            autoloadSelectedAddress(record.job.address.pubId);
        }
    }, [record, addressOptions]);
    var loadAddressDetail = function (addressPubId) {
        var address = addresses === null || addresses === void 0 ? void 0 : addresses.filter(function (address) { return (address === null || address === void 0 ? void 0 : address.pubId) === addressPubId; });
        setDetailAddress(address);
    };
    useEffect(function () {
        if (JobProcessFormik.values.talentAddressPubId && !!(addresses === null || addresses === void 0 ? void 0 : addresses.length)) {
            loadAddressDetail(JobProcessFormik.values.talentAddressPubId);
        }
    }, [JobProcessFormik.values.talentAddressPubId, addresses]);
    var optionCity = cities &&
        cities.data &&
        cities.data.length > 0 &&
        cities.data.map(function (city) { return ({
            label: city.name,
            value: city.pubId,
        }); });
    var optionProductCategories = (productCategory &&
        productCategory.length > 0 &&
        productCategory.map(function (pcategory) { return ({
            label: pcategory.name,
            value: pcategory.pubId,
        }); })) ||
        [];
    var optionBankTransfer = bankTransfer &&
        bankTransfer.data.length > 0 &&
        bankTransfer.data.map(function (bank) { return ({
            name: bank.name,
            value: bank.pubId,
        }); });
    var onChangeFiles = function (e) {
        var _a;
        setFiles(__assign(__assign({}, files), (_a = {}, _a[e.target.name] = e.target.files, _a)));
        JobProcessFormik.setFieldValue(e.target.name, e.target.files);
    };
    initialFormValues.talentAddressPubId = (_4 = (_3 = record.job) === null || _3 === void 0 ? void 0 : _3.address) === null || _4 === void 0 ? void 0 : _4.pubId;
    initialFormValues.talentBankAccountPubId = (_6 = (_5 = record.job) === null || _5 === void 0 ? void 0 : _5.bankAccount) === null || _6 === void 0 ? void 0 : _6.pubId;
    initialFormValues.ktpNumber = record === null || record === void 0 ? void 0 : record.talent.ktpNumber;
    initialFormValues.ktpName = record === null || record === void 0 ? void 0 : record.talent.ktpName;
    initialFormValues.npwpNumber = (_7 = record === null || record === void 0 ? void 0 : record.talent.npwpNumber) === null || _7 === void 0 ? void 0 : _7.trim();
    initialFormValues.npwpName = record === null || record === void 0 ? void 0 : record.talent.npwpName;
    initialFormValues.npwpStatus =
        initialFormValues.npwpNumber || initialFormValues.npwpName ? NpwpStatus.NPWP : '';
    var onChangeAddress = function (e) {
        setSelectedAddress(e);
        JobProcessFormik.setFieldValue('talentAddressPubId', e.value);
        // Reset the formik prefilled values
        if (e.value === 'add-new') {
            JobProcessFormik.setFieldValue('address.recipientName', '');
            JobProcessFormik.setFieldValue('address.recipientPhoneNumber', '');
            JobProcessFormik.setFieldValue('address.address', '');
            JobProcessFormik.setFieldValue('address.cityPubId', '');
        }
    };
    var onChangeBank = function (e) {
        setSelectedBankAccount(e);
        JobProcessFormik.setFieldValue('talentBankAccountPubId', e.value);
        // Reset the formik prefilled values
        if (e.value === 'add-new') {
            JobProcessFormik.setFieldValue('bank.bankPubId', '');
            JobProcessFormik.setFieldValue('bank.accountNumber', '');
            JobProcessFormik.setFieldValue('bank.accountName', '');
            JobProcessFormik.setFieldValue('bank.branchName', '');
            JobProcessFormik.setFieldValue('bank.cityPubId', '');
        }
    };
    var onChangeCityAddress = function (e) {
        setSelectedCityAddress(e);
        JobProcessFormik.values.addressCity = e.value;
        JobProcessFormik.values.address.cityPubId = e.value;
    };
    var onChangeBankName = function (e) {
        setSelectedBankName(e);
        JobProcessFormik.values.bank.bankPubId = e.value;
    };
    var onChangeCityBank = function (e) {
        setSelectedCityBank(e);
        JobProcessFormik.values.bankCity = e.value;
        JobProcessFormik.values.bank.cityPubId = e.value;
    };
    var onChangeCourier = function (e) {
        setSelectedCourier(e);
        JobProcessFormik.values.sendProduct.courierPubId = e.value;
    };
    var _32 = useState({
        pajakType: '',
        pajakMethod: '',
        pajakCategory: '',
        totalTransferredFee: 0,
    }), filterTaxFee = _32[0], setFilterTaxFee = _32[1];
    var _33 = useGenerateTax(id, filterTaxFee), taxFee = _33.taxFee, refetchGenerateTax = _33.refetch;
    useEffect(function () {
        setFilterTaxFee(function (prev) { return (__assign(__assign({}, prev), { totalTransferredFee: isTerm
                ? Number(JobProcessFormik.values.pajakBruto.replace(/\./g, ''))
                : record === null || record === void 0 ? void 0 : record.job.totalFee })); });
    }, [JobProcessFormik.values.pajakBruto]);
    useEffect(function () {
        if (filterTaxFee) {
            refetchGenerateTax(filterTaxFee);
        }
    }, [filterTaxFee]);
    var generateTaxFee = function () {
        // JobProcessFormik.values.pajakBruto = isTerm ? `${JobProcessFormik.values.pajakBruto}`.replace(/\./g, '') : `${taxFee?.pajakBruto}`.replace(/\./g, '')
        JobProcessFormik.values.pajakBruto = "".concat(taxFee === null || taxFee === void 0 ? void 0 : taxFee.pajakBruto).replace(/\./g, '');
        JobProcessFormik.values.pajakCategory = taxFee === null || taxFee === void 0 ? void 0 : taxFee.pajakCategory;
        JobProcessFormik.values.pajakFee = "".concat(taxFee === null || taxFee === void 0 ? void 0 : taxFee.pajakPPh).replace(/\./g, '');
        JobProcessFormik.values.pajakMethod = taxFee === null || taxFee === void 0 ? void 0 : taxFee.pajakMethod;
        JobProcessFormik.values.pajakPPN =
            JobProcessFormik.values.pajakCategory === PajakCategory.PPh23PlusPPNInc ||
                JobProcessFormik.values.pajakCategory === PajakCategory.PPh23PlusPPNExc ||
                JobProcessFormik.values.pajakCategory === PajakCategory.PPh4ayat2PlusPPNInc ||
                JobProcessFormik.values.pajakCategory === PajakCategory.PPh4ayat2PlusPPNExc ?
                "".concat(taxFee === null || taxFee === void 0 ? void 0 : taxFee.pajakPPN).replace(/\./g, '') : '';
        JobProcessFormik.values.pajakType = taxFee === null || taxFee === void 0 ? void 0 : taxFee.pajakType;
        JobProcessFormik.values.totalTransferredFee = "".concat(taxFee === null || taxFee === void 0 ? void 0 : taxFee.totalTransferredFee).replace(/\./g, '');
        JobProcessFormik.values.termTransferAmount = "".concat(taxFee === null || taxFee === void 0 ? void 0 : taxFee.totalTransferredFee).replace(/\./g, '');
    };
    var handleAddNewSendProduct = function () {
        var newItem = {
            qty: 1,
            productPubId: '',
            productCategoryPubId: '',
        };
        setInitialFormValues(__assign(__assign({}, JobProcessFormik.values), { sendProduct: __assign(__assign({}, JobProcessFormik.values.sendProduct), { products: __spreadArray(__spreadArray([], JobProcessFormik.values.sendProduct.products, true), [newItem], false) }) }));
    };
    var handleRemoveSendProduct = function (index) {
        var updatedProducts = JobProcessFormik.values.sendProduct.products;
        updatedProducts.splice(index, 1);
        setInitialFormValues(__assign(__assign({}, JobProcessFormik.values), { sendProduct: __assign(__assign({}, JobProcessFormik.values.sendProduct), { products: updatedProducts }) }));
    };
    useEffect(function () {
        setInitialFormValues(JobProcessFormik.values);
    }, []); //JobProcessFormik.values
    return (_jsx(_Fragment, { children: _jsx(DrawerComponent, __assign({ open: isOpen, size: 'LG', handleClose: handleClose, title: 'Process Kerja Sama' }, { children: _jsx("form", __assign({ className: 'form w-100', onSubmit: JobProcessFormik.handleSubmit, noValidate: true, id: 'job-process-form' }, { children: record && (_jsxs("div", { children: [_jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Nama Talent" })) }), _jsx("div", { children: _jsx(Typography, __assign({ variant: 'h6' }, { children: record.talent.name })) })] })), _jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Contact Person" })) }), _jsx("div", { children: _jsxs(Typography, __assign({ variant: 'h6' }, { children: [record.talent.cpName, " - ", record.talent.cpPhoneNumber] })) })] })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(MultiSelectFormik, { name: 'talentAddressPubId', label: 'Alamat Talent', formik: JobProcessFormik, isMulti: false, options: addressOptions, value: selectedAddress, onchange: onChangeAddress, isRequired: true, isDisabled: isLoadingAddress }), detailAddress &&
                                    detailAddress.length > 0 &&
                                    detailAddress.map(function (address, index) { return (_jsxs("div", __assign({ style: { padding: '1rem', background: '#f9f9f9', borderRadius: '10px' } }, { children: [_jsxs(Typography, __assign({ variant: 'h6' }, { children: [address.recipientName, " - ", address.recipientPhoneNumber] })), _jsxs(Typography, __assign({ variant: 'h6' }, { children: [address.address, ", ", address.city.name, ", ", address.city.province.name] }))] }), index)); }), JobProcessFormik.values.talentAddressPubId === 'add-new' && (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nama Penerima', type: 'text', placeholder: 'Nama Penerima', name: 'address.recipientName', formik: JobProcessFormik, isChildField: true, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nomor Penerima', type: 'text', placeholder: 'Nomor Penerima', name: 'address.recipientPhoneNumber', formik: JobProcessFormik, isChildField: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: 'Alamat', placeholder: 'Alamat', name: "address.address", formik: JobProcessFormik, isChildField: true, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: optionCity && (_jsx(MultiSelectFormik, { name: 'address.cityPubId', label: 'Kota/Kabupaten', formik: JobProcessFormik, isMulti: false, options: optionCity, value: selectedCityAddress, onchange: onChangeCityAddress, isChildField: true, isRequired: true })) }))] }))] })), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(MultiSelectFormik, { name: 'talentBankAccountPubId', label: 'Talent Bank Account', formik: JobProcessFormik, isMulti: false, options: bankAccountOptions, value: selectedBankAccount, onchange: onChangeBank, isRequired: true }), JobProcessFormik.values.talentBankAccountPubId === 'add-new' && (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(MultiSelectFormik, { name: 'bank.bankPubId', label: 'Bank', formik: JobProcessFormik, isMulti: false, options: bankList || [], value: selectedBankName, onchange: onChangeBankName, isChildField: true, isRequired: true, isDisabled: isLoadingBankAccount }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nomor Rekening', type: 'text', placeholder: 'Nomor Rekening', name: 'bank.accountNumber', formik: JobProcessFormik, isChildField: true, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nama Penerima', type: 'text', placeholder: 'Nama Penerima', name: 'bank.accountName', formik: JobProcessFormik, isChildField: true, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Kantor Cabang', type: 'text', placeholder: 'Kantor Cabang', name: 'bank.branchName', formik: JobProcessFormik, isChildField: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: optionCity && (_jsx(MultiSelectFormik, { name: 'bank.cityPubId', label: 'Kota/Kabupaten', formik: JobProcessFormik, isMulti: false, options: optionCity, value: selectedCityBank, onchange: onChangeCityBank, isChildField: true })) }))] }))] })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(SelectFormik, { name: 'isSendProduct', label: 'Kirim Barang', formik: JobProcessFormik, optionList: defaultOptionSendItem, isRequired: true }), JobProcessFormik.values.isSendProduct === 'Send Item' && (_jsxs(Fragment, { children: [courierList && !isLoadingCouriers && (_jsx(MultiSelectFormik, { name: 'sendProduct.courierPubId', label: 'Kurir', formik: JobProcessFormik, isMulti: false, options: courierList, value: selectedCourier, onchange: onChangeCourier, isChildField: true, isRequired: true })), _jsx(TextAreaFormik, { label: 'Note', placeholder: 'Note', name: 'sendProduct.notes', formik: JobProcessFormik, isChildField: true }), _jsxs("div", __assign({ className: 'mb-5' }, { children: [_jsx("div", __assign({ className: 'float-start' }, { children: _jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "List Barang" })) })), _jsx("div", __assign({ className: 'float-end mb-3' }, { children: _jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-success', onClick: handleAddNewSendProduct }, { children: "Tambah Barang" })) }))] })), _jsx("div", __assign({ className: 'my-20' }, { children: _jsx("div", __assign({ className: 'float-start col-md-12' }, { children: initialFormValues &&
                                                    initialFormValues.sendProduct &&
                                                    initialFormValues.sendProduct.products &&
                                                    initialFormValues.sendProduct.products.length > 0 &&
                                                    initialFormValues.sendProduct.products.map(function (_, index) { return (_jsx(SendProductForm, { formik: JobProcessFormik, index: index, categoryOptions: optionProductCategories, onRemove: handleRemoveSendProduct }, index)); }) })) }))] }))] })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(InputFormik, { label: 'No KTP', type: 'text', placeholder: 'No KTP', name: 'ktpNumber', formik: JobProcessFormik, isRequired: true, maxlength: 16 }), _jsx(InputFormik, { label: 'Nama KTP', type: 'text', placeholder: 'Nama KTP', name: 'ktpName', formik: JobProcessFormik, isRequired: true }), _jsx(SelectFormik, { label: 'NPWP Status', name: 'npwpStatus', formik: JobProcessFormik, optionList: dummyNpwpStatusOptions, isRequired: true }), JobProcessFormik.values.npwpStatus === NpwpStatus.NPWP && (_jsxs(Fragment, { children: [_jsx(InputFormik, { label: 'No NPWP', type: 'text', placeholder: 'No NPWP', name: 'npwpNumber', formik: JobProcessFormik, isRequired: true, isNPWP: true }), _jsx(InputFormik, { label: 'Nama NPWP', type: 'text', placeholder: 'Nama NPWP', name: 'npwpName', formik: JobProcessFormik, isRequired: true })] }))] })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(SelectFormik, { label: 'Metode Pembayaran', name: 'paymentMethod', formik: JobProcessFormik, optionList: dummyTransferOption, isRequired: true }), _jsx(SelectFormik, { label: 'Metode Transfer', name: 'transferMethod', formik: JobProcessFormik, optionList: dummyTransferMethodOptions, isRequired: true, onInput: function (e) {
                                        JobProcessFormik.values.transferMethod = e.target.value;
                                        setIsTerm(e.target.value === TransferMethod.TRANSFERPERTERM ? true : false);
                                    } }), _jsxs("div", { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Pajak Status', name: 'pajakType', formik: JobProcessFormik, optionList: dummyTaxOptions, isRequired: true, onInput: function (e) {
                                                    JobProcessFormik.values.pajakType = e.target.value;
                                                    setFilterTaxFee(function (prev) { return (__assign(__assign({}, prev), { pajakType: e.target.value })); });
                                                } }) })), JobProcessFormik.values.pajakType === PajakType.PAJAK && (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Metode Pajak', name: 'pajakMethod', formik: JobProcessFormik, optionList: dummyTaxMethodOptions, isRequired: true, onInput: function (e) {
                                                            JobProcessFormik.values.pajakMethod = e.target.value;
                                                            setFilterTaxFee(function (prev) { return (__assign(__assign({}, prev), { pajakMethod: e.target.value })); });
                                                        } }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Jenis Pajak', name: 'pajakCategory', formik: JobProcessFormik, optionList: dummyTaxTypeOptions, isRequired: true, onInput: function (e) {
                                                            JobProcessFormik.values.pajakCategory = e.target.value;
                                                            setFilterTaxFee(function (prev) { return (__assign(__assign({}, prev), { pajakCategory: e.target.value })); });
                                                        } }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Bruto', type: 'text', placeholder: 'Bruto', name: 'pajakBruto', formik: JobProcessFormik, isRequired: true, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx("button", __assign({ className: 'btn btn-sm btn-success mx-2', onClick: function () {
                                                            generateTaxFee();
                                                        } }, { children: "Generate Tax" })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Pajak PPH', type: 'text', placeholder: 'Pajak PPH', name: 'pajakFee', formik: JobProcessFormik, isRequired: true, formatNumber: true, onfocus: handleFocus }) })), JobProcessFormik.values.pajakType === PajakType.PAJAK &&
                                                    (JobProcessFormik.values.pajakCategory === PajakCategory.PPh23PlusPPNInc ||
                                                        JobProcessFormik.values.pajakCategory === PajakCategory.PPh23PlusPPNExc ||
                                                        JobProcessFormik.values.pajakCategory === PajakCategory.PPh4ayat2PlusPPNInc ||
                                                        JobProcessFormik.values.pajakCategory === PajakCategory.PPh4ayat2PlusPPNExc) && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Pajak PPN', type: 'text', placeholder: 'Pajak PPN', name: 'pajakPPN', formik: JobProcessFormik, isRequired: true, formatNumber: true, onfocus: handleFocus }) }))), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Fee Ditransfer', type: 'text', placeholder: 'Fee Ditransfer', name: 'totalTransferredFee', formik: JobProcessFormik, formatNumber: true, onfocus: handleFocus }) }))] }))] }), _jsx(TextAreaFormik, { label: 'Note', placeholder: 'Note', name: "termNote", formik: JobProcessFormik }), JobProcessFormik.values.transferMethod === TransferMethod.TRANSFERPERTERM && (_jsx(InputFormik, { label: 'Total Transfer #1', type: 'text', placeholder: 'Total Transfer #1', name: 'termTransferAmount', isRequired: true, formik: JobProcessFormik, formatNumber: true, onfocus: handleFocus }))] })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(FileFormik, { label: 'Invoice', placeholder: 'Invoice', name: 'invoiceFilePubId', isRequired: true, formik: JobProcessFormik, onChange: onChangeFiles }), _jsx(FileFormik, { label: 'SPK', placeholder: 'SPK', name: 'spkFilePubId', formik: JobProcessFormik, onChange: onChangeFiles })] })), _jsx(Divider, {}), optionCompanies && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(MultiSelectFormik, { name: 'companyPubId', label: 'Company', formik: JobProcessFormik, isMulti: false, isRequired: true, options: optionCompanies, value: selectedCompany, onchange: onChangeCompany }) }))), !isLoadingBankTransfer && optionBankTransfer && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Transfer dari', name: 'bankTransferByPubId', isRequired: true, formik: JobProcessFormik, optionList: optionBankTransfer, disabled: bankTransferValue !== 0 ? false : true }) }))), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(Typography, __assign({ variant: 'h6' }, { children: [_jsx("b", { children: "Sisa Saldo:" }), " Rp.", saldoTeams === null || saldoTeams === void 0 ? void 0 : saldoTeams.data.total.toLocaleString()] })) })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx(Typography, __assign({ variant: 'h6', className: 'fw-bolder' }, { children: "Aktifitas" })), _jsx(Activity, { datas: activityData, id: id ? id : '' })] })), _jsx(Divider, {}), _jsxs("div", __assign({ className: 'my-5 d-flex flex-row flex-column-fluid' }, { children: [_jsx("div", { style: { textAlign: 'left' }, className: 'd-flex flex-row-fluid flex-left' }), _jsxs("div", __assign({ style: { textAlign: 'right' }, className: 'd-flex flex-column-auto flex-right' }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: handleClose, disabled: JobProcessFormik.isSubmitting, style: { marginRight: '1rem' } }, { children: _jsx("span", __assign({ className: 'indicator-label' }, { children: "Batal" })) })), _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-sm', disabled: JobProcessFormik.isSubmitting, style: { marginRight: '1rem' } }, { children: [!loading && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), loading && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] }))] }))] })) })) })) }));
};
export default ProcessJob;
